/** `window.devicePixelRatio`, or 1 when there is no window or the value is unusable. */
export function getDevicePixelRatio(): number {
  if (typeof window === 'undefined') return 1

  const dpr = window.devicePixelRatio

  return Number.isFinite(dpr) && dpr > 0 ? dpr : 1
}
